import { PharmaCompanyForm } from '@/pages/pharma-companies/components/PharmaCompanyForm';
import React from 'react';

export const PharmaCompanyCreatePage: React.FC = () => (
  <PharmaCompanyForm mode="create" />
);
